'use strict';

const internals = {};


module.exports = {
    settingsCache: Symbol('settingsCache')
};



// WEBPACK FOOTER //
// ./node_modules/@hapi/joi/lib/types/symbols.js